import React, { useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { WebService } from "../../Services/WebService";
import { InputText } from "../Form";
import { useDispatch } from "react-redux";
import TableComponent, { NoRecordTemplate } from "../../Services/TableComponent";
import { StandardConst } from "../../Services/StandardConst";
import ActionButton from "../../Services/ActionButton";
import { Link, useNavigate } from "react-router-dom";
import { Badge, Button } from "react-bootstrap";
import { BadgeOutlined, BadgeRounded, Handshake, Person } from "@mui/icons-material";
import { WSSuccessAlert, WSWarningAlert } from "../../Services/WSAlert";

const { forwardRef, useState, useImperativeHandle } = React;

const LoginByCompanyName = ({ origin }, ref) => {
    const dispatch = useDispatch();
    const [show, setShow] = useState(false);
    const [searchContent, setSearchContent] = useState("");
    const [searchedCompanyData, setSearchedCompanyData] = useState([]);
    const [userType, setUserType] = useState(null);
    const navigate=useNavigate();
    const [selected, setSelected] = useState("");
    const [showWarning,setShowWarning] = useState(false)

    useEffect(() => {setUserType(null)},[])

    useImperativeHandle(ref, () => ({
        openModal: async (id) => {
            setUserType(null);
        setShow(true);
        },
    }));

    const handleUserSelection = (type) => {
      setSelected(type)
        if (type === "no_company") {
            navigate('/nonCompanyUserLogin') // Redirect if no company
        } else {
            setUserType(type); // Show search input if Employee or Customer
        }
    };

    const handleClose = () => {
        setShow(false);
        setSearchedCompanyData([]);
    };

    const searchCompany = async () => {
      console.log(typeof searchContent)
      if (searchContent.trim().length < 4) {
       setShowWarning(true);
       return;
      }else{
        setShowWarning(false)
      }
      
        if(searchContent){
            await WebService({
                endPoint: `CompanyProfile/FetchCompanyByName?SearchContent=${searchContent}`,
                method: "GET",
                dispatch,
            }).then(res => res.length > 0 ? setSearchedCompanyData(res): setSearchedCompanyData([]));
        }else{
            setSearchedCompanyData([]);
        }
    }

    var columns = [
        {
            Text: "Company Name",
            Value: "CompanyName",
        },
        {
            Text: "",
            render: (dr) => (
                <div className="d-flex justify-content-end">
                    <Link to={`${userType=='customer' ? 'User/':''}Login?company=${dr.Code}`}>
                        <button
                            className="btn btn-primary"
                            id="loginbtn"
                        >
                            Login&nbsp;{">>"}
                        </button>
                    </Link>
                </div>
            ),
          },
    ]

  
   

    return (
      <Modal size="lg" centered show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {userType !== null ? "Search your company name and login here" : "Tell us who you are"}
          </Modal.Title>
        </Modal.Header>

        <div className="p-3">
          {userType === null ? (
            // Show selection options initially
            <div className="container mt-5">
  <div className="row g-4 justify-content-center">
    
    <div className="col-md-4 d-flex">
      <div
        className="p-4 text-center rounded shadow box-item border-2 border-primary w-100 d-flex flex-column align-items-center justify-content-center"
        onClick={() => handleUserSelection("employee")}
        style={{ cursor: "pointer", minHeight: "250px" }}
      >
        <div className="mb-3">
          <BadgeRounded color="primary" sx={{ fontSize: 40 }} />
        </div>
        <h5>I am an Employee</h5>
        <p className="mt-2">
          Access tools and HR features for your company.
        </p>
      </div>
    </div>

    <div className="col-md-4 d-flex">
      <div
        className="p-4 text-center rounded shadow box-item border-2 border-primary w-100 d-flex flex-column align-items-center justify-content-center"
        onClick={() => handleUserSelection("customer")}
        style={{ cursor: "pointer", minHeight: "250px" }}
      >
        <div className="mb-3">
          <Handshake color="primary" sx={{ fontSize: 40 }} />
        </div>
        <h5>I am a Customer</h5>
        <p className="mt-2" style={{ opacity: 0.9 }}>
          Manage your purchased services or communicate with the company.
        </p>
      </div>
    </div>

    <div className="col-md-4 d-flex">
      <div
        className="p-4 text-center rounded shadow box-item border-2 border-primary w-100 d-flex flex-column align-items-center justify-content-center"
        onClick={() => handleUserSelection("no_company")}
        style={{ cursor: "pointer", minHeight: "250px" }}
      >
        <div className="mb-3">
          <Person color="primary" sx={{ fontSize: 40 }} />
        </div>
        <h5>Non Company User</h5>
        <p className="mt-2">Login as Candidate or other roles</p>
      </div>
    </div>

  </div>
</div>

          ) : (
            // Show search input if Employee or Customer
            <>
              <div className="row">
                <div className="col-12">
                  <div className="position-relative">
                    <InputText
                      className="form-control pr-2"
                      style={{ paddingRight: "45px" }}
                      placeholder="Company Name"
                      setValue={(val) => setSearchContent(val)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          searchCompany();
                        }
                      }}
                    />
{                   showWarning &&    <span className="text-warning">Please provide at least 4 charachters</span>
}                    <ActionButton
                      className="position-absolute"
                      style={{ top: "0px", right: "0px" }}
                      onClick={searchCompany}
                      IconName="Search"
                      id={`btnSearch`}
                    />
                  </div>
                </div>
              </div>

              {searchedCompanyData.length > 0 ? (
                <TableComponent
                  columns={columns}
                  data={searchedCompanyData}
                  IsAddButtonVisible={false}
                  isExcelExportButtonVisible={false}
                  isSearchRequired={false}
                />
              ) : (
                <NoRecordTemplate
                  headerValue={"Search Your Company"}
                  imageUrl={StandardConst.imageNoRecordsFound}
                />
              )}
            </>
          )}
        </div>
      </Modal>
    );
};

export default forwardRef(LoginByCompanyName);
